import * as React from "react";
const XIcone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#4F2E03"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m20.5 1.5-19 19m0-19 19 19"
    />
  </svg>
);
export default XIcone;
